import React, { useState } from 'react';
import { onboardingFlow } from '../../config/quizConfig.js';
import { ScreenShell } from '../ui/Primitives.jsx';
import StepRenderer from './StepRenderer.jsx';

// Tipos de etapa que pertencem ao "quiz" propriamente dito (tela cheia com
// pergunta + opções). Tudo que vem depois de 'discount_reveal' (results,
// paywall, etc.) é orquestrado pelo App.jsx, não por este componente — o
// QuizFlow cuida só da parte "pergunta atrás de pergunta".
//
// Boundary trocada de 'analyzing' pra 'discount_reveal' em 02/10/2026: as
// telas antigas entre elas (experience, analyzing, etc.) foram removidas —
// ver comentário em quizConfig.js — e agora o quiz termina mesmo no cupom
// (BR) ou no email (demais mercados, onde discount_reveal pula sozinho pro
// onNext sem mostrar nada — ver DiscountRevealStep em StepRenderer.jsx),
// indo direto pro paywall em seguida.
const QUIZ_STEP_IDS = onboardingFlow
  .map((s) => s.id)
  .slice(0, onboardingFlow.findIndex((s) => s.id === 'discount_reveal') + 1);

const quizSteps = onboardingFlow.filter((s) => QUIZ_STEP_IDS.includes(s.id));

/**
 * @param {(answers: object) => void} onComplete - chamado quando o quiz
 *   termina (depois da tela 'analyzing'), com todas as respostas coletadas.
 */
export default function QuizFlow({ onComplete }) {
  const [index, setIndex] = useState(0);
  const [answers, setAnswers] = useState({});

  const step = quizSteps[index];
  const isLast = index === quizSteps.length - 1;

  function handleAnswer(value) {
    setAnswers((prev) => ({ ...prev, [step.id]: value }));
  }

  function handleNext() {
    if (isLast) {
      onComplete(answers);
      return;
    }
    setIndex((i) => i + 1);
  }

  function handleBack() {
    setIndex((i) => Math.max(0, i - 1));
  }

  const showProgress = step.step && step.totalSteps;
  const showBack = index > 0 && step.type !== 'loading-analysis';

  return (
    <ScreenShell
      onBack={showBack ? handleBack : null}
      progress={showProgress ? { step: step.step, totalSteps: step.totalSteps } : null}
    >
      <StepRenderer
        step={step}
        gender={answers.gender ?? 'female'}
        answers={answers}
        value={answers[step.id]}
        onAnswer={handleAnswer}
        onNext={handleNext}
        onBack={handleBack}
      />
    </ScreenShell>
  );
}
